// import React from 'react'
// import { Link } from 'react-router-dom'
// import LocalVideoModal from '../../components/LocalVideoModal'
// import DubaiSouthCarousel from './DubaiSouthCarousel'


// const About = (props) => {
//     const ClickHandler = () => {
//         window.scrollTo(10, 0);
//     }
//     return (
//         <div className={`wpo-about-area section-padding ${props.abClass}`}>
//             <div className="container">
//                 <div className="row align-items-center">
//                     <div className="col-lg-5 col-md-12 col-sm-12">
//                         <div className="wpo-about-img">
//                             <DubaiSouthCarousel />
//                         </div>
//                     </div>
//                     <div className="col-lg-7 col-md-12 colsm-12">
//                         <div className="wpo-about-text">
//                             <div className="wpo-about-title">
//                                 <br />
//                                 <span>About MAAKDREAM</span>
//                                 <h2>A Legacy Continues from Pakistan to Dubai</h2>
//                             </div>
//                             <h5>Founded in 1951, MAAKSONS has grown into one of Pakistan's most trusted construction powerhouses, now expanding internationally through MAAKDREAM in Dubai.</h5>
//                             <p>MAAKDREAM is the real estate brand of the future, born from the legacy of MAAKSONS Engineering Corporation Ltd. With over 70 years of experience in delivering national megaprojects, MAAKDREAM brings the same discipline, quality, and visionary planning to the world of lifestyle development.</p>

//                             <div className="company-highlights">
//                                 <div className="row">
//                                     <div className="col-md-6">
//                                         <div className="highlight-item">
//                                             <h6><i className="fi flaticon-planning"></i> Over 7 Decades</h6>
//                                             <p>Continuous operations in engineering, construction, and urban development</p>
//                                         </div>
//                                     </div>
//                                     <div className="col-md-6">
//                                         <div className="highlight-item">
//                                             <h6><i className="fi flaticon-blueprint"></i> Specialized Expertise</h6>
//                                             <p>Roads, bridges, embassies, tunnels, flyovers, and commercial towers</p>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="btns">
//                                 <Link to="/project" onClick={ClickHandler} className="theme-btn">View Our Projects</Link>
//                                 <ul>
//                                     <li className="video-holder">
//                                         <LocalVideoModal />
//                                     </li>
//                                     <li className="video-text">
//                                         Watch Our Story
//                                     </li>
//                                 </ul>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default About;











import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LocalVideoModal from '../../components/LocalVideoModal';
import DubaiSouthCarousel from './DubaiSouthCarousel';
import api from '../../api/axiosConfig';

const About = (props) => {

    const [data, setData] = useState(null);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    // Fetch about data from backend
    useEffect(() => {
        const fetchAbout = async () => {
            try {
                const res = await api.get("Home/about/");
                setData(res.data[0]); // Only one active about section
            } catch (error) {
                console.error("Error fetching About data:", error);
            }
        };
        fetchAbout();
    }, []);

    // Do NOT render until data is loaded
    if (!data) return null;

    return (
        <div className={`wpo-about-area section-padding ${props.abClass}`}>
            <div className="container">
                <div className="row align-items-center">

                    {/* LEFT: DYNAMIC CAROUSEL */}
                    <div className="col-lg-5 col-md-12 col-sm-12">
                        <div className="wpo-about-img">
                            <DubaiSouthCarousel
                                images={data.aboutus}
                                overlayContent={data.overlay_content}
                            />
                        </div>
                    </div>

                    {/* RIGHT: DYNAMIC TEXT */}
                    <div className="col-lg-7 col-md-12 colsm-12">
                        <div className="wpo-about-text">

                            <div className="wpo-about-title">
                                <br />
                                <span>{data.about}</span>
                                <h2>{data.title}</h2>
                            </div>

                            <h5>{data.founded}</h5>
                            <p>{data.experience}</p>

                            <div className="company-highlights">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="highlight-item">
                                            <h6>
                                                <i className="fi flaticon-planning"></i> 
                                                {data.decades}
                                            </h6>
                                            <p>{data.decades_p}</p>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="highlight-item">
                                            <h6>
                                                <i className="fi flaticon-blueprint"></i> 
                                                {data.expertise}
                                            </h6>
                                            <p>{data.expertise_p}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="btns">
                                <Link 
                                    to={data.linkBtn_one} 
                                    onClick={ClickHandler} 
                                    className="theme-btn"
                                >
                                    {data.textBtn_one}
                                </Link>

                                <ul>
                                    <li className="video-holder">
                                        <LocalVideoModal />
                                    </li>
                                    <li className="video-text">
                                        {data.textBtn_two}
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default About;
